import { inject, Injectable, signal } from '@angular/core';
import { CommonHttpService } from '../common-http.service';
import { environment } from '../../../environments/environment';
import { IItemDonationRequest } from '../../models/IItemDonationRequest';
import { catchError, from, Observable, switchMap, tap, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { IItemDonationResponse } from '../../models/IItemDonationResponse';
import { IItemDomationConfigDTO } from '../../models/IItemDomationConfigDTO';


@Injectable({
  providedIn: 'root'
})
export class ItemDonationService {

  private http = inject(HttpClient);
  private httpService = inject(CommonHttpService);
  private oidcSecurityService = inject(OidcSecurityService);

  itemDonationSignal = signal<IItemDonationResponse | null>(null);

  ItemDomationConfigSignal = signal<IItemDomationConfigDTO | null>(null);


  postItemDonation(itemDonationData: IItemDonationRequest, auctionId: number, donorImage: File | null,
    itemImages: File[]): Observable<IItemDonationResponse> {

    const url = `${environment.apiUrl}/v3/auctions/${auctionId}/item-donation`;
    const formData = new FormData();
    formData.append('donation', JSON.stringify(itemDonationData));

    if (donorImage) {
      formData.append('donorImage', donorImage);
    }

    if (itemImages && itemImages.length > 0) {
      itemImages.forEach(file => {
        if (file) {
          formData.append('itemImages', file);
        }
      });
    }

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          let headers = new HttpHeaders()
            .set('Accept', 'application/json');

          headers = headers.set('Authorization', `Bearer ${authResult.accessToken}`);

          return this.http.post<IItemDonationResponse>(url, formData, {
            headers
          });
        } else {
          return throwError(() => new Error('unauthenticated user or expired token'));
        }
      }),
      tap(response => {
        // console.log('status received:', response);
        this.itemDonationSignal.set(response);
      }),
      catchError((error: HttpErrorResponse) => {
        const errorMsg =
          typeof error.error === 'string' ? error.error : 'Unknown Error';
        console.error('API Error:', errorMsg);
        return throwError(() => new Error(errorMsg));
      })
    );
  }

  public getItemDonationConfig(auctionId:number): Observable<IItemDomationConfigDTO> {
      const url = `${environment.apiUrl}/v3/auctions/${auctionId}/item-donation-config`;
  
      return from(this.oidcSecurityService.checkAuth()).pipe(
        switchMap(authResult => {
            return this.httpService.get<IItemDomationConfigDTO>(url, undefined, undefined);
        }),
        tap(response => {
          this.ItemDomationConfigSignal.set(response);
        }),
        catchError((error: HttpErrorResponse) => {
          const errorMsg = typeof error.error === 'string' ? error.error : 'Unknown Error';
          return throwError(() => new Error(errorMsg));
        })
      );
    }

}
